import styled from '@emotion/styled';
import type { ReactionNameEnum } from '@hotjar/webapp/features/Playbacks/ReactionIcons';

import { reactionsSvgOutline } from '@hotjar/labels';

const StyledImg = styled.img`
  filter: drop-shadow(1px 0px 2px #c3c3c3);
`;

enum SizeEnum {
  m = 'm',
  l = 'l',
  xl = 'xl',
}

interface Props {
  name: ReactionNameEnum;
  size?: 'm' | 'l' | 'xl';
  tiltRight?: boolean;
}

const sizeInPxByName: { [name in SizeEnum]: number } = {
  m: 16,
  l: 32,
  xl: 48,
};

export const ReactionSticker = ({
  name,
  size = 'm',
  tiltRight = false,
}: Props): JSX.Element | null => {
  const svgString = reactionsSvgOutline[name];
  const sizeInPx = sizeInPxByName[size];
  return svgString ? (
    <StyledImg
      src={svgString}
      width={sizeInPx}
      height={sizeInPx}
      style={{
        transform: `rotate(${tiltRight ? 8 : -8}deg)`,
      }}
    />
  ) : null;
};
